<template>
	<div class="main">
		<div class="flex box article-content">
			<div class="eight">
				<article-editor-content
						:editor-content="data.articleEditorContent"
						:errors="errors"
						:key="state"
				></article-editor-content>
			</div>
			<aside class="four">
				<article-editor-general
						:editor-general="data.articleEditorGeneral"
						:generated-url="generatedUrl"
						:is-save-draft-disabled="isSaveDraftDisabled"
						:errors="errors"
						:data-auth-pixel-hash="authPixelHash"
				></article-editor-general>
				<article-editor-labels v-if="data.id" :articleId="data.id" :labels="data.labels"></article-editor-labels>
				<article-editor-advanced v-if="data.id" :editor-advanced="data.articleEditorAdvanced"></article-editor-advanced>
				<article-editor-health-checker v-if="data.id" :editor-health-checker="data.articleEditorHealthChecker"></article-editor-health-checker>
				<article-editor-translators v-if="data.id" :editor-translators="data.articleEditorGeneral.translators"></article-editor-translators>
			</aside>
		</div>

		<modal :modal-name="'articlePublish'">
			<template #modal-header>
				<h4 class="modal-title" v-if="healthCheckerErrors.length === 0">Confirm Article Publication</h4>
				<h4 class="modal-title" v-if="healthCheckerErrors.length > 0">Please fix these issues before publishing</h4>
			</template>
			<template #modal-body>
				<div class="flex box">
					<div class="seven">
						<div class="flex box">
							<div class="form-group twelve-lg" v-if="healthCheckerErrors.length > 0">
								<table>
									<thead>
										<tr>
											<th>Rule</th>
											<th>Error</th>
										</tr>
									</thead>
									<tbody>
										<tr v-bind:class="{ 'text-danger': result.result === 300 }" v-for="result in healthCheckerErrors">
											<td>{{ result.rule }}</td>
											<td class="text-center"
												v-bind:class="{
													'text-success': result.result === 0,
													'text-warning': result.result === 100,
													'text-danger': result.result === 200 || result.result === 300,
												}">
												{{ result.message }}
												<ul v-if="result.items.length > 0">
													<li v-for="item in result.items" v-if="item.code === 200">{{ item.text }}</li>
												</ul>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="form-group twelve-lg" v-if="healthCheckerErrors.length === 0">
								<table>
									<tbody>
										<tr v-if="!data.articleEditorGeneral.isScheduled">
											<td :colspan="2">
												<div class="switches">
													<input id="publish_date-1" name="publish_date" class="switch-true" type="radio" value="1" v-model="publishConfirmation.publish_date">
													<label class="label-checkbox" @click="publishConfirmationUpdater('publish_date',1)">Yes</label>
													<input id="publish_date-0" name="publish_date" class="switch-false" type="radio" value="0" v-model="publishConfirmation.publish_date">
													<label class="label-checkbox" @click="publishConfirmationUpdater('publish_date',0)">No</label>
												</div>
											</td>
											<td>
												I want to update the displayed date
											</td>
										</tr>
										<tr v-if="data.articleEditorGeneral.isScheduled">
											<td :colspan="2">
												<div class="switches">
													<input id="publish_date-1" name="publish_date" class="switch-true" type="radio" value="1" v-model="publishConfirmation.publish_date">
													<label class="label-checkbox" @click="publishConfirmationUpdater('publish_date',1)">Yes</label>
													<input id="publish_date-0" name="publish_date" class="switch-false" type="radio" value="0" v-model="publishConfirmation.publish_date">
													<label class="label-checkbox" @click="publishConfirmationUpdater('publish_date',0)">No</label>
												</div>
											</td>
											<td>
												I understand that this is a scheduled post and will be published on {{ data.articleEditorGeneral.display_date }} automatically! Until that, the post will be 404, even if it was published before!
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template #modal-footer>
				<a class="btn btn-md btn-success" @click="publish" :disabled="!canWePublish"  v-if="healthCheckerErrors.length === 0"><i class="fas fa-check"></i> Publish</a>
			</template>
		</modal>
	</div>
</template>

<script>
import Errors from "../../Utils/Errors";
import {eventBus} from "../../app";
import Modal from "../Modal/Modal.vue";

export default {
	components: {
		Modal
	},
	props: {
		data: {
			required: true
		},
		dataAuthPixelHash: {
			type: String
		}
	},
	data() {
		return {
			isSaveDraftDisabled: false,
			clickedLang: this.$defaultLanguage.locale,
			errors: new Errors(),
			originalCategoryId: _.clone(this.data.articleEditorGeneral.category_id),
			originalProviderTypeId: _.clone(this.data.articleEditorGeneral.selected_provider_type_id),
			redirectNeeded: false,
			state: 0,
			redirect: {
				url_from: null,
				url_to: null
			},
			publishConfirmation: {
				publish_date: null,
			},
			canWePublish: false,
			healthCheckerErrors: [],
			authPixelHash: this.dataAuthPixelHash
		}
	},
	created() {
		let vm = this;
		// When setActiveStatus method ran, change selected data in form fields
		/* From LangSelector */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		/* From ArticleEditorAdvanced */
		eventBus.$on('onLoadRevision', function (selectedRevisionId) {
			vm.loadRevision(selectedRevisionId);
		});

		/* From ArticleEditorGeneral */
		eventBus.$on('onArticleDraftSave', function () {

			if (vm.redirectNeeded && vm.data.id) {
				vm.$dialog.confirm('Do you really want to change the article provider type or category? Automatic redirects will be generated.', {
					loader: true
				}).then(function (dialog) {
					vm.data.articleEditorGeneral.redirectNeeded = true;
					vm.getRedirect();
					vm.data.articleEditorGeneral.redirect = vm.redirect;
					vm.saveDraft();
					dialog.close();
				}).catch(function () {
					eventBus.$emit('onLoaderFinish');
				});
			} else {
				vm.saveDraft();
			}
		});

		/* From ArticleEditorGeneral */
		eventBus.$on('onArticlePublish', function () {
			if (vm.redirectNeeded && vm.data.id) {
				vm.$dialog.confirm('Do you really want to change the article provider type or category? Automatic redirects will be generated.', {
					loader: true
				}).then(function (dialog) {
					vm.data.articleEditorGeneral.redirectNeeded = true;
					vm.getRedirect();
					vm.data.articleEditorGeneral.redirect = vm.redirect;
					vm.prePublishModal();
					dialog.close();
				}).catch(function () {
					eventBus.$emit('onLoaderFinish');
				});
			} else {
				vm.prePublishModal();
			}
		});

		/* From ArticleEditor */
		eventBus.$on('onEnableSaveDraft', function () {
			vm.isSaveDraftDisabled = false;
		});

		vm.$watch('data', function (newVal) {
			if (newVal.articleEditorGeneral.category_id != vm.originalCategoryId || newVal.articleEditorGeneral.selected_provider_type_id != vm.originalProviderTypeId) {
				vm.redirectNeeded = true;
			}
		}, {deep: true});

		eventBus.$on('onModalClose', function () {
			eventBus.$emit('onLoaderFinish');
		});

		vm.articleInUse();
	},
	beforeDestroy() {
		eventBus.$off('onLoadRevision');
		eventBus.$off('onArticleDraftSave');
		eventBus.$off('onArticlePublish');
		eventBus.$off('onEnableSaveDraft');
	},
	computed: {
		generatedUrl: function () {
			if (this.data.articleEditorGeneral.category_id) {
				let categorySlug = this.data.articleEditorGeneral.categories[this.data.articleEditorGeneral.category_id].slug;
				return process.env.MIX_BASE_PP_URL +
						(this.clickedLang === 'en' ? '' : this.clickedLang + '/') +
						(this.data.articleEditorGeneral.selected_provider_type_id ? (this.data.articleEditorGeneral.providerTypes[this.data.articleEditorGeneral.selected_provider_type_id].slug + '/') : '') +
						categorySlug + '/' + this.data.articleEditorContent.translations[this.clickedLang].slug;
			}
		}
	},
	methods: {
		articleInUse: function () {
			let vm = this;
			if (vm.data.articleEditorContent.id) {
				axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id + '/inuse', {
					user_id: vm.$currentUser.id
				}).then(function () {
					setTimeout(vm.articleInUse, 30000);
				});
			}
		},
		loadRevision: function (selectedRevisionId) {
			let vm = this;
			if (vm.data.articleEditorContent.id) {
				axios.get('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id + '/getRevision/' + selectedRevisionId)
						.then(function (response) {
							let selectedRevision = response.data.revision.find(element => element.locale === vm.clickedLang);
							if (selectedRevision) {
								vm.data.articleEditorContent.translations[vm.clickedLang] = {
									slug: selectedRevision.slug,
									content: selectedRevision.content,
									title: selectedRevision.title,
									card_title: '',
									card_text: '',
									card_code: '',
								};

								vm.$toastr.success('The selected revision loaded successfully', 'Success');
							} else {
								this.$toastr.error('The selected revision not available the current language.', 'Error');
							}

							eventBus.$emit('onLoaderFinish');
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinished');
							vm.errors.record(e.response.data);
							this.$toastr.error('Load revision failed.', 'Error');
						});
			}
		},
		saveDraft: function (callback) {
			let vm = this;
			let originData = _.cloneDeep(vm.data);
			vm.errors.clear();
			//Ezt itt azért kell így csinálni, mert ha a vm.data-ból törlöm ki akkor mentés után nem fognak menni a fordítások
			for (let i = 0; i < this.$availableLanguages.length; i++) {
				if (originData.articleEditorContent['translations'][this.$availableLanguages[i].locale] &&
						originData.articleEditorContent['translations'][this.$availableLanguages[i].locale].title === '' &&
						originData.articleEditorContent['translations'][this.$availableLanguages[i].locale].slug === '' &&
						originData.articleEditorContent['translations'][this.$availableLanguages[i].locale].content === '') {
					delete (originData.articleEditorContent['translations'][this.$availableLanguages[i].locale]);
				}
			}
			if (vm.data.articleEditorContent.id) {
				axios.put('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id, originData)
						.then(function (response) {
							if (response.data) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Article draft saved.', 'Success');
								vm.data.articleEditorHealthChecker.result = response.data.articleHealth;
								if (callback) {
									callback();
								}
								vm.data.articleEditorGeneral.redirect = null;
							} else {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.error('Article draft save failed.', 'Error');
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Article draft save failed.', 'Error');
							vm.isSaveDraftDisabled = true;
							vm.errors.record(e.response.data);
						});
			} else {
				axios.post('/api/' + vm.$selectedSite.slug + '/articles', originData)
						.then(function (response) {
							if (response.data) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Article draft saved.', 'Success');

								window.onbeforeunload = null;
								window.location.replace(process.env.MIX_APP_URL + vm.$selectedSite.slug + '/articles/' + response.data.article_id + '/edit?tab=content');
							} else {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.error('Article draft save failed.', 'Error');
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Article draft save failed.', 'Error');
							vm.isSaveDraftDisabled = true;
							vm.errors.record(e.response.data);
						});
			}
			vm.redirectNeeded = false;
		},
		prePublishModal: function () {
			this.getHealthCheckerErrors();
			this.publishConfirmation = {
				publish_date: null,
			};
			this.canWePublish = false;

			eventBus.$emit('onModalOpen_articlePublish');
		},
		publish: function () {
			if (this.canWePublish === false) {
				return true;
			}
			eventBus.$emit('onModalClose_articlePublish');
			let vm = this;
			vm.saveDraft(function () {
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id + '/publish',
					{
						publishConfirmation: vm.publishConfirmation
					})
					.then(function (response) {
						if (response.data.success) {
							vm.$toastr.success('Article published successfully', 'Success');
							vm.articleHasDraft = false;
							eventBus.$emit('onLoaderFinish');
						} else {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(function (e) {
						eventBus.$emit('onLoaderFinish');
						vm.errors.record(e.response.data);
						vm.$toastr.error('Article publishing failed.', 'Error');
					});
			});
		},
		publishConfirmationUpdater(variable, value) {
			this.publishConfirmation[variable] = value;
			this.canWePublish = this.publishConfirmation['publish_date'] != null;
			if (this.data.articleEditorGeneral.isScheduled && this.publishConfirmation['publish_date'] === 0) {
				this.canWePublish = false;
			}
		},
		getHealthCheckerErrors: function () {
			let vm = this;
			this.healthCheckerErrors = [];

			if (this.data.id && this.data.hasOwnProperty('articleEditorHealthChecker') && this.data.articleEditorHealthChecker.hasOwnProperty('result') && typeof this.data.articleEditorHealthChecker.result !== 'undefined' && this.data.articleEditorHealthChecker.result.length > 0) {
				this.data.articleEditorHealthChecker.result.forEach(function (entry) {
					if (entry.result > 100) {
						vm.healthCheckerErrors.push(entry);
					}
				});
			}
		},
		getRedirect: function () {
			let oldProviderTypeSlug = '',
				newProviderTypeSlug = '',
				newCategorySlug = this.data.articleEditorGeneral.categories[this.data.articleEditorGeneral.category_id].slug,
				oldCategorySlug = this.data.articleEditorGeneral.categories[this.originalCategoryId].slug;

			if (this.originalProviderTypeId !== null) {
				oldProviderTypeSlug = this.data.articleEditorGeneral.providerTypes[this.originalProviderTypeId].slug + '/'
			} // if

			if (this.data.articleEditorGeneral.selected_provider_type_id !== null) {
				newProviderTypeSlug = this.data.articleEditorGeneral.providerTypes[this.data.articleEditorGeneral.selected_provider_type_id].slug + '/';
			} // if

			this.originalCategoryId = this.data.articleEditorGeneral.category_id;
			this.originalProviderTypeId = this.data.articleEditorGeneral.selected_provider_type_id;

			// skip if category is PPC in this case "c"
			if (newCategorySlug !== 'c' || oldCategorySlug !== 'c') {
				this.redirect.url_from = oldProviderTypeSlug + oldCategorySlug + '/';
				this.redirect.url_to = newProviderTypeSlug + newCategorySlug + '/';
			} // if
		}
	}
}
</script>

<style scoped>

</style>
